/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Link, useNavigate } from "react-router-dom";
import * as formik from "formik";
import * as yup from "yup";
import {
  useUserRegister,
  useUserSignIn,
} from "../../../../../../api/mutations/auth.mutation";
import { signInSuccess } from "../../../../../../store";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../../store/hook";
import * as RoleSelector from "src/store/role/selector";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import DatePicker from "react-datepicker";
import { useState } from "react";

function BasicInfoForm() {
  const { Formik } = formik;

  const schema = yup.object().shape({
    email: yup.string().required("Please enter your email"),
    password: yup.string().required("Please enter your password"),
    rememberMe: yup.bool(),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = useAppSelector(RoleSelector.selectUserRole);

  const userLoginMutation = useUserSignIn({
    onSuccess: (data) => {
      dispatch(signInSuccess("token"));
      navigate("/u");
    },
    onError: (error) => {
      if (error.message) {
      }
    },
    successMessage: "Login Successful!",
  });

  const [selectedDate, setSelectedDate] = useState(null);
  const onSignIn = (data) => {};

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSignIn}
      initialValues={{
        email: "",
        password: "",
        rememberMe: false,
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        values,
        touched,
        errors,
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Row className="mb-2">
            <h3 className="mb-3 fs-4">Personal Information</h3>
            <Form.Group
              as={Col}
              controlId="validationFormikFacebook"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Birth Date</Form.Label>
              <div>
                <DatePicker
                  selected={values.birthdate}
                  onChange={(date) => setFieldValue("birthdate", date)}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  placeholderText="Select birthdate"
                />
              </div>
            </Form.Group>
            <Form.Control.Feedback type="invalid">
              {errors.birthdate}
            </Form.Control.Feedback>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikWebsite"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Gender</Form.Label>
              <Form.Control
                type="gender"
                placeholder="Male"
                name="gender"
                value={values.gender}
                onChange={handleChange}
                className="form-control mb-0"
              />
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationInstagram"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Age</Form.Label>
              <Form.Control
                type="age"
                placeholder="24"
                name="age"
                value={values.age}
                onChange={handleChange}
                isInvalid={!!errors.age}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.age}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationYoutube"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Interested in
              </Form.Label>
              <Form.Control
                type="interest"
                placeholder="Designing"
                name="interest"
                value={values.interest}
                onChange={handleChange}
                className="form-control mb-0"
              />
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationYoutube"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Qualification
              </Form.Label>
              <Form.Control
                type="qualification"
                placeholder="Bachelor Degree in Computing"
                name="qualification"
                value={values.qualification}
                onChange={handleChange}
                className="form-control mb-0"
              />
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikAddress"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Description
              </Form.Label>
              <Form.Control
                as="textarea"
                type="description"
                placeholder="About yourself"
                name="description"
                value={values.description}
                onChange={handleChange}
                className="form-control mb-0"
                rows={4}
              />
            </Form.Group>
          </Row>
          <div className="text-end">
            <Button
              variant="success-subtle"
              type="submit"
              className="btn btn-success mt-4 fw-semibold text-uppercase"
            >
              Save & Update
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default BasicInfoForm;
